<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-faded position-absolute w-100 topmenu pr-0">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <span v-if="ShowStoreLink">STORES</span>
        </router-link>
        <ul class="nav float-right account-btns">
          <li class="cart">
            <a href="#" @click.prevent="navigateShoppingcart">
              <i class="material-icons">shopping_cart</i>
              {{ cartTotal | formatMoney }}
            </a>
          </li>
          <li v-if="user" class="dropdown">
            <a
              id="navbarDropdown"
              class="dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="material-icons">person</i>
              {{ user.email }}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link class="dropdown-item" to="/profile">My Account</router-link>
              <router-link
                class="dropdown-item"
                :to="{ name: useStampCollection?'userStamps':'loyalty', params: {storeid: currentStoreDoc.ID, storename: currentStoreDoc.Name.split(' ').join('-') } }"
              >Loyalty</router-link>
              <router-link
                class="dropdown-item"
                :to="{ name: 'orderhistory', params: {storeid: currentStoreDoc.ID, storename: currentStoreDoc.Name.split(' ').join('-') } }"
              >Order History</router-link>
              <router-link
                class="dropdown-item"
                :to="{ name: 'ordertracking', params: {storeid: currentStoreDoc.ID, storename: currentStoreDoc.Name.split(' ').join('-') } }"
              >Order Tracking</router-link>
              <a class="dropdown-item" href="#" @click="signOut">Log Out</a>
            </div>
          </li>
          <li v-if="!user && viewConfig.LogIn" @click.prevent="$emit('open-overlay')">
            <a href="#">
              <i class="material-icons">person</i>
              Log in
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template> 

<script>
import { mapActions, mapGetters } from "vuex";
import { $$ } from "./../../sharedscripts/OO_jquery";
export default {
  name: "TopMenu",
  computed: {
    ...mapGetters([
      "user",
      "cartValue",
      "giftCartValue",
      "viewConfig",
      "currentstore",
      "isGift",
      "currentStoreDoc",
      "useStampCollection"
    ]),
    cartTotal() {
      return this.isGift ? this.giftCartValue : this.cartValue;
    },
    ShowStoreLink() {
      return !this.isGift && this.isBranded();
    }
  },
  mounted() {
    $$(".dropdown").hover(function() {
      $$(".dropdown-toggle").dropdown("hide");
    });
  },
  methods: {
    ...mapActions(["logout"]),
    signOut() {
      this.logout();
      this.$router.push("/");
    },
    navigateShoppingcart() {
      if (window.location.pathname.indexOf("giftcards") != -1)
        this.$router.push("/store/" + this.currentstore + "/giftcards");
      else this.$router.push("/store/" + this.currentstore);
    }
  }
};
</script>
